export default {
  passwordRegex: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/,
  subdomain: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}$/,
  accountName: /^[a-zA-Z0-9\-]+([_\s]?[a-zA-Z0-9\-])*$/,
  url: /^(ftp:\/\/|http:\/\/|https:\/\/).*$/,
  domain: /^([\w-]+\.)*[\w\-]+\.\w{2,10}$/
}

export const isValidURL = (url: string | null) => {
  try {
    new URL(url as string)
    return true
  } catch (_) {
    return false
  }
}

export const MAX_CSV_USER_IMPORT_LENGTH = 70000

export const isValidHttpsUrl = (str: string) => {
  return isValidURL(str) && new URL(str).protocol === 'https:'
}
